module.exports = "/_next/static/images/thick-right-arrow-f59bfa26de9f59945813dbebce5008d8.svg";